module.exports = __webpack_public_path__ + "img/campanha-e-comissao.cbfc69d2.svg";